exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zalog__btn[data-v-46742a8e] {\n  margin-bottom: 15px;\n}\n.zalog .empty-message[data-v-46742a8e] {\n  color: #777;\n  margin: 15px 0;\n  font-size: 16px;\n  line-height: 18px;\n  display: inline-block;\n}\n", ""]);

// exports
